import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
  name: 'formatPhone',
  standalone: true
})
export class FormatPhonePipe implements PipeTransform {
transform(value: string | null | undefined): string {
    if (!value) return '';
    const phone = value.replace(/\D/g, '');
    if (phone.startsWith('0800')) {
      return phone.replace(/(\d{4})(\d{3})(\d{4})/, '$1 $2 $3');
    } else if (phone.length === 11) {
      return phone.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
    } else if (phone.length === 10) {
      return phone.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
    }
    return value;
  }
}